<template>
  <v-navigation-drawer
    app
    fixed
    clipped
    :mini-variant="mini">
    <v-list>
      <v-tooltip right v-for="item in items" :key="item.name">
        <v-list-tile
          slot="activator"
          :to="item.link"
          router-link
          @click="item.click"
          ripple>
          <v-list-tile-title>{{ item.name }}</v-list-tile-title>
        </v-list-tile>
        <span>{{ item.tooltip || item.name }}</span>
      </v-tooltip>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'Navigation',
  props: {
    initMini: {
      type: Boolean
    },
    items: {
      type: Array,
      default: _ => []
    }
  },
  data () {
    return {
      mini: this.initMini
    }
  }
}
</script>
